/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { PACK_P2C_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { P2cPage } from "@/features/processing/components/p2c-page";

export const Route = createFileRoute("/_app/packaging/p2c/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(PACK_P2C_FORM))
      throw redirect({ to: "/packaging/p2c" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <P2cPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
